import { combineReducers } from 'redux';
import Auth from './Auth';
import Request from './Request';
import Notification from './Notification';
import Pricing from './Pricing';
import Structure from './Structure';
import Settings from './Settings';
import Theme from './Theme';

const reducers = combineReducers({
    theme: Theme,
    auth: Auth,
    request: Request,
    structure: Structure,
    settings: Settings,
    notification: Notification,
    pricingReducer: Pricing
});

export default reducers;